import { useTranslation } from "react-i18next";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import {
  BreadCrumbItem,
  Breadcrumb,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import { Content } from "../../../../general/modules/commons/content/content";
import useCrudForm from "../../../../../hooks/useCrudForm";
import { WarehouseMutateFormTemplate } from "../commons/warehouseMutateFormTemplate/warehouseMutateFormTemplate";
import { useParams } from "react-router-dom";
import {
  warehouseCreateSchema,
  WarehouseModel,
  warehouseSchema,
} from "../../domain/schemas/warehouseSchema";
import { Col, Row } from "react-bootstrap";
import { CrudForm } from "../../../../general/modules/commons/crud/crudForm";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const WarehouseMutatePage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const { id } = useParams();

  const model = useAppSelector((state) => state.crudMutate)
    .model as WarehouseModel;

  const title = model.id
    ? t("warehouse.mutate.edit", { name: model.name })
    : t("warehouse.mutate.create");

  const crud = useCrudForm({
    schema: model.id ? warehouseSchema : warehouseCreateSchema,
    prefix: "warehouses",
    createMutation: "generateCompleteWarehouse",
    updateMutation: "upsertWarehouse",
    deleteMutation: "deleteWarehouse",
    id: id ? parseInt(id) : undefined,
    formTemplate: WarehouseMutateFormTemplate,
    queryExclude: ["number_of_paths", "number_of_positions", "height"],
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem to="/warehouses">{t(`Warehouses`)}</BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>{crud.form}</Content>
        <Content md={4}>
          {crud.manageHeader}
          {crud.manage}
        </Content>
      </LayoutContent>

      {model.id ? null : (
        <LayoutContent>
          <Content md={8}>
            <CrudForm
              schema={warehouseCreateSchema}
              prefix={"warehouses"}
              form={crud.formLogic}
              formTemplate={() => (
                <Row>
                  <Col md="8">
                    <CrudPlaceholderInput name="number_of_paths" />
                  </Col>
                  <Col md="8">
                    <CrudPlaceholderInput name="number_of_positions" />
                  </Col>
                  <Col md="8">
                    <CrudPlaceholderInput name="height" />
                  </Col>
                </Row>
              )}
              disabledFields={undefined}
            />
          </Content>
        </LayoutContent>
      )}
    </Layout>
  );
};
